module.exports = __webpack_public_path__ + "img/Incative.9a7bb9be.svg";